export default "__VITE_ASSET__83f4ee74__"